import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { StudentData, StudentService } from '../../services/student.service';
import { Utils } from '../../util';
import { toast, MaterializeAction } from 'angular2-materialize';
import { ProductVntaService, PrVnta } from '../../services/product-vnta.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-create-student',
  templateUrl: './create-student.component.html',
  styleUrls: ['./create-student.component.css']
})
export class CreateStudentComponent implements OnInit {

  form: FormGroup;
  assignmentsSelect: {value: string, name: string}[];
  assignments: string[] = [];
  assignment: string = '';
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: StudentService,
    private data: StudentData,
    private prVntaService: ProductVntaService,
    private fb: FormBuilder,
  ) {
    this.assignmentsSelect = Object.keys(data.assignments).map(key => {
      return {value: key, name: data.assignments[key]}
    });
    this.assignment = this.assignmentsSelect[0].value;


    this.prVntas = {};
    this.prVntaSub = this.prVntaService.getPrVntas().subscribe(prVntas => {
      this.rowsRead[0] = prVntas.map(prVnta => {
        this.prVntas[prVnta.id] = prVnta;
        prVnta.class = prVnta.data.name;
        return prVnta;
      })
    });
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      birthdate: ['', Validators.required],
      semester: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let student = {
      assignments: this.assignments,
      prVntaRef: this.service.prVntaReference(this.selectedIds[0]),
      ...value
    }
    
    this.service.addStudent(student);
    this.service.windowReplace('read');
  }


  touchAssignment(){
    if(this.assignments.includes(this.assignment)) return toast('You can not add duplicates.', 3000);
    this.assignments.push(this.assignment);
  }
  removeAssignment(index: number){
    this.assignments.splice(index, 1);
  }


  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];

  prVntas: {[x: string]: PrVnta} = {};
  prVntaSub: Subscription;

  selectedIds: string[] = [''];
  currentReadIndex: number = 0;

  rowsRead = [[]];
  columnsRead = [
    [//prVnta
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
    ],
  ]

  Data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.Data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
  }
  unselectRead(index: number){
    this.closeModalRead();
    this.selectedIds[index] = '';
  }

  get readValid(){ return this.selectedIds[0] };
  


  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.Data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.Data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
